import CryptoJS from "crypto-js";

// Use a fallback key if .env is not set. 
// In a real app, this should be in .env and kept secure.
const SECRET_KEY = process.env.REACT_APP_URL_ENCRYPTION_KEY || "rai-metal-inventory-secret-key-2024";

/**
 * Encrypts a string or number for use in a URL.
 */
export const encrypt = (text) => {
  if (text === null || text === undefined) return "";
  const stringText = String(text);
  try {
    const ciphertext = CryptoJS.AES.encrypt(stringText, SECRET_KEY).toString();
    // Make it URL safe (replace +, / and =)
    return btoa(ciphertext)
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  } catch (error) {
    console.error("Encryption error:", error);
    return "";
  }
};

/**
 * Decrypts a string from a URL.
 */
export const decrypt = (encodedText) => {
  if (!encodedText) return "";
  try {
    // Restore URL safe characters
    let base64 = encodedText.replace(/-/g, "+").replace(/_/g, "/");
    while (base64.length % 4) {
      base64 += "=";
    }
    const ciphertext = atob(base64);
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
    const originalText = bytes.toString(CryptoJS.enc.Utf8);
    return originalText;
  } catch (error) {
    return "";
  }
};

/**
 * Encrypts all parameters in a path that match /:param pattern.
 * Note: This is a helper for manual path building.
 */
export const encryptPath = (path, params = {}) => {
  let encryptedPath = path;
  Object.entries(params).forEach(([key, value]) => {
    encryptedPath = encryptedPath.replace(`:${key}`, encrypt(value));
  });
  return encryptedPath;
};
